export const name = "TIMESTAMP_ADD";
export const summary = `Adds a specified time interval to a \`TIMESTAMP\` value.`;
export const reference = `
## TIMESTAMP_ADD

Adds a specified time interval to a \`TIMESTAMP\` value.

\`\`\`
TIMESTAMP_ADD(timestamp_expression, INTERVAL int64_expression date_part)
\`\`\`

### Description

Adds \`int64_expression\` units of \`date_part\` to the timestamp, independent of any time zone.

\`TIMESTAMP_ADD\` supports the following values for \`date_part\`:

- \`MICROSECOND\`
- \`MILLISECOND\`
- \`SECOND\`
- \`MINUTE\`
- \`HOUR\`. Equivalent to 60 \`MINUTE\` parts.
- \`DAY\`. Equivalent to 24 \`HOUR\` parts.


### Return Data Types

\`TIMESTAMP\`


### Example



\`\`\`
SELECT
  TIMESTAMP("2008-12-25 15:30:00+00") AS original,
  TIMESTAMP_ADD(TIMESTAMP "2008-12-25 15:30:00+00", INTERVAL 10 MINUTE) AS later;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------+-------------------------*
 | original | later |
 +-------------------------+-------------------------+
 | 2008-12-25 15:30:00 UTC | 2008-12-25 15:40:00 UTC |
 *-------------------------+-------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
